import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

import CheckIcon from 'mdi-react/CheckCircleIcon';
import InfoIcon from 'mdi-react/InfoCircleIcon';
import WarningIcon from 'mdi-react/WarningCircleIcon';

export const Message = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 1;
`;

export const iconStyles = css`
  margin-right: ${layout.spacing.small};
`;

export const Check = styled(CheckIcon)`
  ${iconStyles}
`;

export const Info = styled(InfoIcon)`
  ${iconStyles}
`;

export const Warning = styled(WarningIcon)`
  ${iconStyles}
`;
